/* eslint-disable class-methods-use-this */
import { ReportGrammarRules } from '../../../../../../../redux/config/customReport/types'
import { ReportDataType } from '../../../../../../../redux/context/reports/types'
import { NodesById, NormalizedBuilderNode } from '../types'
import { NormalizedAbstractVisitor } from './NormalizedAbstractVisitor'

/**
 * ResetVisitor normalisoidulle puurakenteelle
 * Resetoi tietyt solmut tapahtuman perusteella
 */
export class NormalizedResetVisitor extends NormalizedAbstractVisitor<void> {
  private event: Partial<NormalizedBuilderNode>

  private onUpdateValues: (id: string, values: Partial<NormalizedBuilderNode>) => void

  constructor(
    rules: ReportGrammarRules,
    nodesById: NodesById,
    event: Partial<NormalizedBuilderNode>,
    onUpdateValues: (id: string, values: Partial<NormalizedBuilderNode>) => void
  ) {
    super(rules, nodesById, true) // traverseAll = true
    this.event = event
    this.onUpdateValues = onUpdateValues
  }

  /**
   * Resetoi puun
   * @param rootNodeId Root-solmun ID
   */
  public reset(rootNodeId: string): void {
    this.visit(rootNodeId)
  }

  // Visit-metodit eri solmutyypeille
  visitRootNode(): void {
    // Ei resetoida
  }

  visitCompanyNode(): void {
    // Ei resetoida
  }

  visitDimensionNode(node: NormalizedBuilderNode): void {
    if (this.event.type === 'company') {
      // Päivitetään arvot onUpdateValues-funktiolla, ei suoraan objektia muokkaamalla
      this.onUpdateValues(node.id, { value: undefined })
    }
  }

  visitPeriodGroupNode(node: NormalizedBuilderNode): void {
    if (this.event.type === 'company') {
      // Päivitetään arvot onUpdateValues-funktiolla, ei suoraan objektia muokkaamalla
      this.onUpdateValues(node.id, { budgetingScenarioId: undefined })

      if (this.event.argumentId && node.dataType === ReportDataType.forecast) {
        this.onUpdateValues(node.id, { dataType: undefined })
      }
    }
  }

  visitFunctionNode(node: NormalizedBuilderNode): void {
    if (this.event.type === 'function') {
      // Funktion lapset tyhjennetään poistamalla ne
      ;(node.childIds || []).forEach((childId: string) => {
        const childNode = this.nodesById[childId]
        if (childNode && childNode.parentId === node.id) {
          // Tämä voisi poistaa lapset suoraan, mutta voi olla parempi jättää se
          // tilanhallintalogiikan vastuulle (onUpdateValues)
          this.onUpdateValues(node.id, { childIds: [] })
        }
      })
    }
  }

  visitReferenceNode(): void {
    // Ei resetoida
  }

  visitKeyFigureNode(): void {
    // Ei resetoida
  }

  visitFormulaNode(node: NormalizedBuilderNode): void {
    if (this.event.type === 'company') {
      // Päivitetään arvot onUpdateValues-funktiolla, ei suoraan objektia muokkaamalla
      this.onUpdateValues(node.id, { value: undefined })
    }
    // Ei resetoida
  }
}
